import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

const notFoundIllustration = `${process.env.PUBLIC_URL}/404.png`;

const ACCENT = "#86BC25";
const ACCENT_HOVER = "#749f1f";

// Route doesn't exist at all — distinct from UnauthorizedAccess (you're
// signed in but not allowed here). Same visual language (Deloitte green,
// pill button, centered layout) so the two feel like one design system, but
// distinct copy so a user can tell "wrong URL" from "no access".
const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        py: 6,
      }}
    >
      <Box sx={{ maxWidth: 720, textAlign: "center" }}>
        <Box
          component="img"
          src={notFoundIllustration}
          alt=""
          sx={{
            width: "100%",
            maxWidth: 620,
            height: "auto",
            display: "block",
            mx: "auto",
            mb: 3,
          }}
        />

        <Typography
          sx={{
            fontSize: { xs: "1.9rem", md: "2.3rem" },
            fontWeight: 800,
            lineHeight: 1.15,
            color: "#14231F",
            mb: 1.5,
          }}
        >
          Page not found
        </Typography>

        <Typography
          sx={{
            fontSize: "1rem",
            color: "#4A5B57",
            maxWidth: 400,
            mx: "auto",
            mb: 4,
          }}
        >
          The page you're looking for doesn't exist or may have moved. Check the URL, or head back to your dashboard.
        </Typography>

        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: ACCENT,
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "999px",
            px: 4,
            "&:hover": { backgroundColor: ACCENT_HOVER },
          }}
          onClick={() => navigate("/dashboard")}
        >
          Back to home dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
